import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=00bcd9b2&scoped=true"
import script from "./Crear.vue?vue&type=script&lang=js"
export * from "./Crear.vue?vue&type=script&lang=js"
import style0 from "./Crear.vue?vue&type=style&index=0&id=00bcd9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bcd9b2",
  null
  
)

export default component.exports